class IllegalStateError extends Error {
  constructor(message, code, extraInfo) {
    super(message);
    this.code = code;
    this.extraInfo = extraInfo;
  }
}

export default IllegalStateError;
